import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, Validators } from '@angular/forms';
import { User } from 'libs/portal/src/models/User';
import { GenericService } from 'libs/portal/src/services/generic/generic.service';
import { Endpoints } from '@huge-monorepo/portal/config';

@Component({
  selector: 'app-edit-user',
  templateUrl: './edit-user.component.html',
  styleUrls: ['./edit-user.component.scss'],
})
export class EditUserComponent implements OnInit {
  @Output() userUpdated: EventEmitter<User> = new EventEmitter<User>();
  @Input() userToUpdate: any;
  @Input() admin: boolean;
  @Input() isInModal: boolean;

  constructor(private formBuilder: UntypedFormBuilder, private genericService: GenericService, private endpoints: Endpoints) {}

  roles = [
    { roleId: 1, roleName: 'General' },
    { roleId: 2, roleName: 'Admin' },
    { roleId: 3, roleName: 'Super User' },
  ];

  emailControl = new UntypedFormControl('', [Validators.required, Validators.email]);
  nameControl = new UntypedFormControl('', [Validators.required]);
  surnameControl = new UntypedFormControl('', [Validators.required]);
  idControl = new UntypedFormControl('', [Validators.required]);
  receiveEmailControl = new UntypedFormControl('', [Validators.required]);
  userRoles = new UntypedFormControl('', Validators.required);

  validations_form = this.formBuilder.group({
    emailControl: this.emailControl,
    nameControl: this.nameControl,
    surnameControl: this.surnameControl,
    userRoles: this.userRoles,
  });

  validation_messages = {
    nameControl: [{ type: 'required', message: 'Name is required.' }],
    surnameControl: [{ type: 'required', message: 'Surname is required.' }],
    emailControl: [
      { type: 'required', message: 'Email is required.' },
      { type: 'email', message: 'Enter valid email.' },
    ],
    userRole: [{ type: 'required', message: 'Select atleast one user role.' }],
  };

  ngOnInit() {
    this.idControl.setValue(this.userToUpdate.id);
    this.nameControl.setValue(this.userToUpdate.firstName);
    this.surnameControl.setValue(this.userToUpdate.lastName);
    this.emailControl.setValue(this.userToUpdate.email);
  }

  updateUser() {
    if (
      this.idControl.value != '' &&
      this.emailControl.value !== '' &&
      this.nameControl.value !== '' &&
      this.surnameControl.value !== '' &&
      this.idControl.errors == null &&
      this.emailControl.errors == null &&
      this.nameControl.errors == null &&
      this.surnameControl.errors == null
    ) {
      const newUser: User = {
        ID: this.idControl.value,
        Name: this.nameControl.value,
        Surname: this.surnameControl.value,
        Email: this.emailControl.value,
        OTPEnabled: false,
        EmailEnabled: this.receiveEmailControl.value,
        GUID: '',
        IsActive: '1',
        UserRoles: [],
        Departments: null,
      };

      const tempUserD = {
        Name: newUser.Name,
        Surname: newUser.Surname,
        Email: newUser.Email,
        GUID: newUser.GUID,
        IsActive: '1',
        EmailEnabled: newUser.EmailEnabled,
        UserRoles: newUser.UserRoles,
      };

      this.genericService.PUT(this.endpoints.UPDATE_USER(newUser.ID), tempUserD).subscribe(() => {
        this.userUpdated.emit(newUser);
      });
    } else {
      this.emailControl.markAsTouched();
      this.idControl.markAsTouched();
      this.nameControl.markAsTouched();
      this.surnameControl.markAsTouched();
    }
  }
}
